
import Vue from "vue";"@/components/SelectSaleLayout.vue";
export default Vue.extend({
	props: {
		value: Boolean
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
